// Tells the Overview "Model Summary" card that the chat regenerated the summary.
//
// The chat panel used to live inside the summary card, so a `summary_refresh`
// activity refreshed both at once. Now the chat is a page-level rail that shows
// on every model tab while the summary card is Overview-only, so the two are no
// longer parent/child. The panel regenerates the cached deliverable server-side
// and emits here; the card, when it is mounted, re-fetches. Same shape as
// treeRefreshBus, minus the coalescing — a summary refresh is one event, not a
// burst.
//
// ponytail: unkeyed on purpose. Only one model is ever in view (ModelPage keys
// its whole subtree on the model), so a listener always wants the current
// model's summary; a late emit after a model switch just re-fetches the new one.

type Handler = () => void;

const handlers = new Set<Handler>();

export function onSummaryRefresh(handler: Handler): () => void {
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}

export function emitSummaryRefresh(): void {
  // One broken listener must not stop the rest.
  [...handlers].forEach((handler) => {
    try {
      handler();
    } catch {
      // ignored on purpose, see above
    }
  });
}
